export const PLACEHOLDER_FORM_HEIGHT = 240;
